export default __webpack_public_path__ + "static/media/indicatorEpisodes.77106bb6.svg";